module.exports = __webpack_public_path__ + "assets/img/icon-7.0441af26.png";